export default __webpack_public_path__ + "static/P_SearchThumb_InstarVision_Android-6f46ea5478c7809caefff16ae3fb0917.webp";